import Component from "./ChipChoice";
import Counter from "./components/Counter/ChipCounter";
import { MainIcon, LeftIcon, RightIcon } from "./components/Icon/ChipIcon";
import Label from "./components/Label/ChipLabel";

interface IChipChoiceExtensions {
    Counter: typeof Counter;
    MainIcon: typeof MainIcon;
    Label: typeof Label;
    LeftIcon: typeof LeftIcon;
    RightIcon: typeof RightIcon;
}

export const ChipChoice: typeof Component & IChipChoiceExtensions =
    Object.assign(Component, {
        Counter,
        MainIcon,
        Label,
        LeftIcon,
        RightIcon,
    });

export type { ChipProps } from "./types";
